import type { GenericSchema } from 'valibot'
import { intersect, nullish, object, optional, string } from 'valibot'
import { workspaceBookSchema, workspaceJournalSchema, workspaceLawSchema, workspaceTemplateSchema } from '~/utils/workspace/favorites'
import { academicArticleSectionSchema, lawReferenceSchema } from './academic-article'
import { baseBodySchema } from './body'
import { bookFootnoteSchema } from './book-footnotes'
import { facetCountsSchema } from './facet'
import { headersSchema } from './headers'
import { solrHighlightingSchema } from './highlighting'
import { journalListSchema } from './journal'
import { bookAndArticleSchema, pageSchema } from './literature'

function docsResponse<const TResponse extends GenericSchema>(response: TResponse) {
  return object({
    responseHeader: headersSchema,
    response,
    highlighting: nullish(solrHighlightingSchema),
    facet_counts: nullish(facetCountsSchema),
  })
}

// One malformed doc must not blank the whole list
export function solrDocsResponseSchema<const TDoc extends GenericSchema>(docSchema: TDoc) {
  return docsResponse(intersect([baseBodySchema, object({ docs: safeArray(docSchema) })]))
}

// journalProfile sits beside docs, and a plain docs schema would strip it
export const solrJournalResponseSchema = docsResponse(intersect([
  baseBodySchema,
  object({ docs: safeArray(journalListSchema), journalProfile: optional(string()) }),
]))

export const solrBookAndArticleResponseSchema = solrDocsResponseSchema(bookAndArticleSchema)
export const solrPageResponseSchema = solrDocsResponseSchema(pageSchema)
export const solrAcademicArticleSectionResponseSchema = solrDocsResponseSchema(academicArticleSectionSchema)
export const solrLawReferenceResponseSchema = solrDocsResponseSchema(lawReferenceSchema)
export const solrBookFootnoteResponseSchema = solrDocsResponseSchema(bookFootnoteSchema)
export const solrWorkspaceLawResponseSchema = solrDocsResponseSchema(workspaceLawSchema)
export const solrWorkspaceBookResponseSchema = solrDocsResponseSchema(workspaceBookSchema)
export const solrWorkspaceJournalResponseSchema = solrDocsResponseSchema(workspaceJournalSchema)
export const solrWorkspaceTemplateResponseSchema = solrDocsResponseSchema(workspaceTemplateSchema)

export function hasSolrParams(params: object | null | undefined): boolean {
  return !!params && Object.values(params).some(value => value != null)
}
